module.exports = __webpack_public_path__ + "img/logo-company.5c9a01e8.png";